import fetch from 'isomorphic-fetch'
import { browserHistory } from 'react-router'
import {
  pendingTask,
  begin,
  end
} from 'react-redux-spinner'
import {
  NEW_EVENT_REQUEST,
  NEW_EVENT,
  NEW_EVENT_ERROR
} from './types'

export function createEventRequest() {
  console.warn('CREATE EVENT REQUEST')
  const data = {
    loading: true
  }
  return {
    type: NEW_EVENT_REQUEST,
    [ pendingTask ]: begin,
    payload: data
  }
}

export function createEventSuccess(event) {
  //console.log('CREATE EVENT SUCCESS')
  const data = {
    loading: false,
    event
  }
  browserHistory.push('/events/')
  return {
    type: NEW_EVENT,
    [ pendingTask ]: end,
    payload: data
  }
}

export function createEventFail(error) {
  console.log('CREATE EVENT FAIL: ' +error)
  const data = {
    loading: false,
    error
  }
  return {
    type: NEW_EVENT_ERROR,
    [ pendingTask ]: end,
    payload: data
  }
}

export function saveEvent(event) {
  console.log('SAVING EVENT: ' +JSON.stringify(event))
  return dispatch => {
    dispatch(createEventRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/events/new`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token')
      },
      body: JSON.stringify(event)
    })
    .then(res => res.json())
    .then(json => {
      dispatch(createEventSuccess(json.body))
    })
    .catch(error => dispatch(createEventFail(error)))
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/event.js
 **/